import axios from "axios";
import { Hex, Piece } from "../game/mechanics";

import { pieceKind, Player, serverAction, actionData } from "../types/game";

const headers = {
  "Content-Type": "application/json",
};

// async function postData(url: string, data: any) {
//   // Default options are marked with *
//   const response = await fetch(url, {
//     method: "POST", // *GET, POST, PUT, DELETE, etc.
//     mode: "cors", // no-cors, *cors, same-origin
//     cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
//     credentials: "same-origin", // include, *same-origin, omit
//     headers: {
//       "Content-Type": "application/json",
//       // 'Content-Type': 'application/x-www-form-urlencoded',
//     },
//     redirect: "follow", // manual, *follow, error
//     referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
//     body: JSON.stringify(data), // body data type must match "Content-Type" header
//   });
//   return response.json(); // parses JSON response into native JavaScript objects
// }

// export const startGame = (playerId: string): Promise<any> => {
//   return postData(
//     "https://us-central1-hive-70e06.cloudfunctions.net/api/game/start",
//     { data: { playerId } }
//   );
// };

export const startGame = (playerId: string) => {
  console.log("axios --> start game");
  return axios.post(
    "https://us-central1-hive-70e06.cloudfunctions.net/api/game/start", // TODO: change for production
    {
      headers,
      data: {
        playerId,
      },
    },
    { withCredentials: false }
  );
};

export const cancelStartGame = (playerId: string) => {
  console.log("axios --> cancel start game");
  return axios.post(
    "https://us-central1-hive-70e06.cloudfunctions.net/api/game/cancelStart", // TODO: change for production
    {
      headers,
      data: {
        playerId,
      },
    },
    { withCredentials: false }
  );
};

export const movePieceServer = (moveData: actionData) => {
  console.log("axios --> move");
  return axios.post(
    "https://us-central1-hive-70e06.cloudfunctions.net/api/game/move", // TODO: change for production
    {
      headers,
      data: moveData,
    },
    { withCredentials: false }
  );
};

const parseHex = (s: string): Hex => {
  const hexCoords = s.split(",");
  if (hexCoords.length !== 2) {
    throw new Error("invalid served move, could not parse hex");
  }
  const q = parseInt(hexCoords[0]);
  const r = parseInt(hexCoords[1]);
  if (isNaN(q) || isNaN(r)) {
    throw new Error("invalid served move, could not parse hex");
  }
  return new Hex(q, r);
};

const parsePiece = (
  coordsStr: string,
  kind: pieceKind,
  owner: Player
): Piece => {
  const coords = coordsStr.split(",");
  if (coords.length !== 3) {
    throw new Error("invalid served move, could not parse piece");
  }
  const q = parseInt(coords[0]);
  const r = parseInt(coords[1]);
  const h = parseInt(coords[2]);

  if (isNaN(q) || isNaN(r) || isNaN(h)) {
    throw new Error("invalid served move, could not parse hex");
  }
  return new Piece(kind, owner, new Hex(q, r), h);
};

export const parseServerAction = (
  moveData: actionData,
  players: Player[]
): serverAction => {
  if (!players.some((p) => moveData.byPlayer === p.id)) {
    throw new Error("action player not found");
  }
  const owner = players.find((p) => moveData.byPlayer === p.id) || players[0];
  return moveData.type === "place"
    ? {
        type: moveData.type,
        pieceKind: moveData.kind as pieceKind,
        owner,
        hex: parseHex(moveData.hex),
      }
    : {
        type: moveData.type,
        piece: parsePiece(moveData.piece, "queen", owner),
        to: parseHex(moveData.to),
      };

  // return moveData.type === "place"
  //   ? {
  //       type: moveData.type,
  //       pieceKind: moveData.kind as pieceKind,
  //       owner: players.find((p) => moveData.byPlayer === p.id),
  //       hex: parseHex(moveData.hex),
  //     }
  //   : {
  //       type: moveData.type,
  //       piece: parsePiece(moveData.piece, "queen", currentPlayer),
  //       to: parseHex(moveData.to),
  //     };
};
